import TimeAgo from "react-timeago";
import { useFirestore } from "react-redux-firebase";
import Moment from "react-moment";
import {
  typeColorCondition,
  contactTypeArray,
} from "../../contact-details/constants";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  font-size: 1rem;
  background: ${({ customer }) => (customer ? "var(--primary)" : "white")};
  border-radius: 5px;
  padding: 15px 10px;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;
  border: 1px solid ${({ color }) => color};
  * {
    color: ${({ customer }) => (customer ? "white" : "grey")};
    font-weight: ${({ customer }) => (customer ? "700" : "300")};
  }
`;

const Name = styled.div`
  font-weight: ${({ customer }) => (customer ? "900" : "700")};
  color: ${({ customer }) => (customer ? "white" : "var(--primary)")};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const Info = styled.div`
  width: 70%;
  font-weight: 500;
`;

const Phone = styled.div`
  font-size: 0.65rem;
`;

const Email = styled.div`
  font-size: 0.6rem;
  a {
  }
`;

const Time = styled.div`
  font-size: 0.75rem;

  color: grey;
`;

const Date = styled.div`
  font-style: italic;
  font-size: 0.6rem;
`;

const Ago = styled.div``;

const Type = styled.div`
  font-size: 0.75rem;
  display: flex;
  align-items: center;

  span {
    font-weight: 800;
  }
`;

const Circle = styled.div`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  border-color: ${({ color }) => color};
  background-color: rgba(0, 0, 0, 0);
  margin-right: 5px;
`;

function ContactMobile({ contact, whenContactClicked, customer }) {
  const firestore = useFirestore();

  const {
    firstName,
    lastName,
    phoneNumber,
    email,
    contactType,
    id,
    createdTime,
  } = contact;

  const handleClickContactType = () => {
    let typeIndex = contactTypeArray.indexOf(contactType);

    return firestore.update(
      { collection: "contacts", doc: id },
      {
        contactType:
          contactTypeArray[(typeIndex + 1) % contactTypeArray.length],
      }
    );
  };

  return (
    <>
      <Container
        onClick={() => whenContactClicked(id)}
        color={typeColorCondition[contactType]}
        customer={customer}
      >
        <Info>
          <Name customer={customer}>
            {(firstName + lastName).length ? `${firstName} ${lastName}` : "_"}
          </Name>
          <Phone>{phoneNumber}</Phone>

          <Email>
            <a
              href={`mailto:${email.toLowerCase()}?subject=Smiling Woods`}
              rel="noreferrer"
              target="_blank"
            >
              {email.toLowerCase()}
            </a>
          </Email>
        </Info>

        <Time>
          {!customer && (
            <Type onClick={handleClickContactType}>
              <Circle color={typeColorCondition[contactType]}></Circle>
              <span style={{ color: typeColorCondition[contactType] }}>
                {contactType.toUpperCase()}
              </span>
            </Type>
          )}
          <Ago>
            <TimeAgo date={createdTime} />
          </Ago>
          <Date>
            <Moment date={createdTime} format="MMMM D, 'YY" />
          </Date>
        </Time>
      </Container>
    </>
  );
}

export default ContactMobile;
